import { Component, Input, OnInit } from '@angular/core';

import { GfTranslateService } from '../../../services/core.translate.service';
import { StateService } from '@uirouter/angular';
import { BoardService } from '../board.service';
import { UserService } from '../../../services/core.user.service';
import { BoardRest } from '../board.rest';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { GfTitleService } from '../../../services/core.title.service';

import * as _ from "lodash-es";
import { BoardDeleteModalComponent } from '../boardDelete/board.delete.component';
import { BoardAddEditModalComponent } from '../boardAddEdit/board.add.edit.component';

@Component({
	selector: 'board-list',
	template: require('./board.list.component.html')
})
export class BoardListComponent implements OnInit {

	@Input() project: any = null;
	@Input() projectMenu: any = null;
	@Input() queries: any = null;
	@Input() sprints: any = null;
	@Input() releases: any = null;

	protected boards: any = false;
	protected sortFields = {
		'boardName': "Name",
		// 'section': "Section",
		'isShared': "Visibility"
	};
	private sort: any = {
		sort_field: 'boardName',
		sort_dir: 'desc'
	};
	private paging: any = {
		page_num: 1,
		page_size: 20
	};
	protected filters = {
		main_fields: {}
	};

	constructor(
		private modalService: NgbModal,
		private boardRest: BoardRest,
		private stateService: StateService, 
		
		private boardService: BoardService,
		private userService: UserService,
		private $window: Window,
		private gfTranslateService: GfTranslateService,
        private titleService: GfTitleService,
	) { }

	ngOnInit() {
		this.sort = {
			sort_field: _.get(this.stateService.params, 'sort_field', 'boardName'),
			sort_dir: _.get(this.stateService.params, 'sort_dir', 'desc')
		};

		this.paging = {
			page_num: _.get(this.stateService.params, 'page_num', 1),
			page_size: _.get(this.stateService.params, 'page_size', 20)
		};

		this.filters = {
			main_fields: this.setFilterValues(
				this.getBaseFilters(), 
				this.stateService.params
			)
		};

		this.titleService.setTitle(this.project.name, 'Planning Boards');

		this.loadProjectBoards();
	};

	updatePaging(params) {
		this.paging = params;
		this.applyFilters();
	};

	onApplyFilters() {
		this.paging.page_num = 1;
		this.applyFilters();
	};

	onResetFilters() {
		this.paging.page_num = 1;
		this.filters = {
			main_fields: this.getBaseFilters()
		};
		this.applyFilters();
	};

	setSort(params) {
		this.sort = {
			sort_field: _.get(params, 'key', 'boardName'),
			sort_dir: _.get(params, 'sortDir', 'asc')
		};
		this.paging.page_num = 1;
		this.applyFilters();
	};

	showDeleteBoard(board: any) {
		const modalRef = this.modalService.open(BoardDeleteModalComponent);
		modalRef.componentInstance.project = this.project;
		modalRef.componentInstance.board = board;
		modalRef.componentInstance.close.subscribe((refresh) => {
		  modalRef.close();
		  if (refresh) {
			this.refresh();
		  }
		});
	};

	refresh() {
		this.loadProjectBoards();
	};

	showBoardAddEditModal(board: any = null) {

		if (! board) {
            board = {
                boardName: '',
                description: '',
                section: 'query',
                refId: null,
                project: this.project.id,
                isShared: 'N',
                config: {
                    query: null,
                    columnSource: {},
                    rowSource: {},
                    collapseEmpty: {
                        columns: 0,
                        rows: 0
                    }
                }
            };			
		}

		const modalRef = this.modalService.open(BoardAddEditModalComponent);
		modalRef.componentInstance.project = this.project;
		modalRef.componentInstance.board = board;
		modalRef.componentInstance.queries = this.queries;
		modalRef.componentInstance.sprints = this.sprints;
		modalRef.componentInstance.releases = this.releases;
		modalRef.componentInstance.close.subscribe((refresh) => {
		  modalRef.close();
		  if (refresh) {
			this.refresh();
		  }
		});
	};

	loadProjectBoards() {
		this.boards = false;

		var params = _.pickBy(this.stateService.params, _.negate(_.isEmpty));
		params.project = this.stateService.params.unixName;
		delete params.unixName;

		const currentUserId = this.userService.getUserId();

		return this.boardRest.getBoards(params)
			.then((response) => {
				this.boards = _.map(
					_.get(response, 'items', []),
					(b) => {
						b.canEdit = (this.projectMenu.admin || (b.user.id == currentUserId));
						return b;
					}
				);
			})
			.catch((response) => {
				this.boards = [];
			});
	}

	applyFilters() {
		var newParams = _.extend(
			this.sort,
			this.paging,
			this.getFilterValues(
				_.get(this.filters, 'main_fields', [])
			)
		);

		this.stateService.go('.', newParams)
			.then(() => this.refresh(), () => this.refresh());
	}

	getFilterValues(filters) {
		return _.reduce(
			filters,
			(carry, f) => {
				carry[f.alias] = _.get(f, 'value.id', _.get(f, 'value', ''));
				return carry;
			},
			{}
		);
	}

	getBaseFilters() {
		var anyTracker = { id: 0, label: 'Any' };
		var trackers = _.concat(anyTracker, _.map(this.project.rel.trackers, function (tracker) {
			return { id: tracker.tracker_id, label: tracker.tracker_name };
		}));

		var visibility = [{ id: '', label: 'Any' }, { id: 'true', label: 'Public' }, { id: 'false', label: 'Private' }],
			sections = [...new Set([{ id: '', label: 'Any' }, ...this.boardService.getSections().map(function (section) {
				return {
					id: section.id,
					label: section.description
				};
			})])];

		return [
			{ alias: 'boardName', fieldName: "Board Name", value: "", fieldType: 4, isExtraField: false },
			// { alias: "section", fieldName: "Section", value: sections[0], fieldType: 1, isExtraField: false, fieldElements: sections },
			{ alias: "isShared", fieldName: "Visibility", value: visibility[0], fieldType: 1, isExtraField: false, fieldElements: visibility }
		];
	}

	setFilterValues(filters, params) {
		return _.map(
			filters,
			function (f) {
				var value = _.get(params, f.alias, '');
				var valObject = _.find(
					_.get(f, 'fieldElements', []),
					function (item) { return item.id == value; }
				);
				_.set(f, 'value', valObject ? valObject : value);
				return f;
			}
		);
	}
}
